module.exports = __webpack_public_path__ + "img/mft-watermark.1e3eb0cc.png";